import './includes/ready.js';
import './includes/scrollto.js';
import './includes/wakelock.js';
import './includes/main.js';

import './includes/tracker.js';
import './includes/bazaarvoice.js';